import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import WizardListBlockData from '../../../Models/Content/WizardListBlockData';
import WizardList from './WizardListBlock';

export default class WizardListBlock extends EpiComponent<WizardListBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    let cssClasses: Array<string> = ['wizard-list-block'];

    return (
      <div className={cssClasses.join(" ")}>
            <WizardList iContent={this.props.data} context={this.getContext()} />
      </div>
    )
  }
}
